import { PerformerEntity } from './performer.entity';

export class VariablePerformerEntity extends PerformerEntity {
  // 变量参与者，已经从固定用户里分离出来了
  varValue: string;
  varType: string;
  relation: string;
  name: string;
  constructor(id?: string, name?: string, type?: string) {
    super(id,name,type);
  }
}
